import axios from "axios";
const token =
  "eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI5NGQ4YzUyM2VkYjBlZTJjNTc3Y2VlMzUxZWZlZWJlMyIsInN1YiI6IjYyMjIxOTM2NDFhYWM0MDAxYjNiYzA0OCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.Teon8qHpQFVyS5JR3klVf98y0tG6Y0BHjXAIkDz8Wxk";
// https://api.themoviedb.org/3/movie/550?api_key=94d8c523edb0ee2c577cee351efeebe3
// const API_KEY = "25da25ddab0e86803373bf86d08768e2";
const API_KEY = "94d8c523edb0ee2c577cee351efeebe3";

export default axios.create({
  baseURL: "https://api.themoviedb.org/3",
  headers: {
    Authorization: `Bearer ${token}`,
  },
  params: {
    api_key: API_KEY,
  },
});
